import React from "react";
import { content } from "../../data";
import Button from "../Button/Button";
import { motion } from "framer-motion";
import MobileHeader from "./MobileHeader";
import StyledH5Heading from "../../common/components/styledH5Heading/StyledH5Heading";

const Header = () => {
  const navItems = content.navItems;

  const handleScroll = (event) => {
    event.preventDefault();
    const targetId = event.currentTarget.getAttribute("href").substring(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, delay: 0.5, ease: "easeInOut" }}
      className="flex justify-center max-w-[2160px] w-full absolute top-0"
    >
      <div className="flex justify-between items-center w-11/12 sm:w-[85%] py-3">
        {/* LOGO */}
        <div className="w-[170px] min-w-[170px]">
          <a href="/">
            <img
              src="/assets/jaba-logo.svg"
              alt="Jaba Logo"
              className="w-full"
            />
          </a>
        </div>

        {/* Nav Items */}
        <div className="hidden lg:flex items-center justify-center gap-5 w-fit">
          {navItems.map((item, index) => (
            <a
              key={index}
              href={item.link}
              onClick={handleScroll}
              className="text-white hover:text-orange transition"
            >
              <StyledH5Heading>{item.title}</StyledH5Heading>
            </a>
          ))}
        </div>

        {/* Buy Now Button */}
        <div className="flex justify-center gap-4 items-stretch">
          <Button
            variant="gradientButton"
            font="hidden sm:flex py-2.5 px-5 sm:py-4 sm:px-9 text-white"
          >
            buy now
          </Button>
          <MobileHeader />
        </div>
      </div>
    </motion.div>
  );
};

export default Header;
